import React from "react";
import { Link } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";

// items: [{ label, to? }] — the last item renders as plain text (current
// page), everything before it is a link.
export default function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Breadcrumb" className="mb-4 flex flex-wrap items-center gap-1.5 text-sm text-slate-500">
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <span key={i} className="flex items-center gap-1.5">
            {i > 0 && <FiChevronRight className="h-3.5 w-3.5 text-slate-300" />}
            {isLast || !item.to ? (
              <span className={isLast ? "font-medium text-slate-700" : ""}>{item.label}</span>
            ) : (
              <Link to={item.to} className="hover:text-primary-600 hover:underline">
                {item.label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
